import { updateSurveyToFillQuestion } from "../../../../../../store/actions/dataEntryFillASurveyActions";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import "./SurveyRankingQuestion.css";

const SurveyRankingQuestion = ({ question, disabled, onChangeAlert }) => {
  const { answer = [], config = {}, options = [], id, error } = question;
  const { color = "#FFC107", iconInfo = ["far", "star"] } = config;
  const [value, setValue] = useState(answer.length ? answer[0] : null);
  const [hoverdValue, setHoverdValue] = useState(null);
  const dispatch = useDispatch();

  const onClickOption = (evt) => {
    if (!disabled) {
      const optionId = evt.currentTarget.dataset?.optionId;
      let castValue = Number(optionId);

      if (castValue === value) {
        castValue = null;
        setValue(null);
      } else {
        setValue(castValue);
      }

      setHoverdValue(null);

      dispatch(
        updateSurveyToFillQuestion({
          questionId: id,
          newData: { answer: castValue ? [castValue] : [], error: null },
        })
      );

      onChangeAlert();
    }
  };

  const onMouseHover = (evt) => {
    if (!disabled) {
      const optionId = evt.currentTarget.dataset?.optionId;
      setHoverdValue(Number(optionId));
    }
  };

  useEffect(() => {
    setValue(answer && answer.length ? answer[0] : null);
  }, [answer]);

  return (
    <>
      <Box className="rating-box">
        {options?.map((option, index) => {
          return (
            <Box
              className={`rating-item ${
                disabled ? "rating-item--disabled" : ""
              }`}
              key={index}
              onClick={onClickOption}
              onMouseEnter={onMouseHover}
              onMouseLeave={() => setHoverdValue(null)}
              data-option-id={option?.value}
            >
              <FontAwesomeIcon
                className="rating-item__icon"
                style={{
                  color: `${
                    value > index || hoverdValue > index ? color : "#0000003B"
                  }`,
                }}
                icon={iconInfo}
              />
              <span className="rating-item__label">{option?.option || ""}</span>
            </Box>
          );
        })}
      </Box>
      {error && <p className="survey-question__error-hint">{error}</p>}
    </>
  );
};

export default SurveyRankingQuestion;
